import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const Navigation = styled.div`
    align-items: center;
    display: flex;
    gap: 48px;
    margin-right: 24px;
`;

export const Link = styled(NavLink)(
    ({ theme: { fontSize, palette } }) => css`
        color: ${palette.text.primary};
        cursor: pointer;
        font-size: ${fontSize[14]}px;
        letter-spacing: -0.015em;
        line-height: 1.4;
        position: relative;
        text-decoration: none;

        &:hover,
        &.active {
            &:after {
                background: ${palette.primary.default};
                bottom: -2px;
                content: '';
                height: 1px;
                left: 0;
                position: absolute;
                width: 100%;
            }
        }
    `,
);
